import React from 'react';
import additional from './financial_grey.svg'

const Financial_grey = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default Financial_grey;
